// extracted by mini-css-extract-plugin
module.exports = {"collapse":"Collapse_collapse__C4s5F"};